import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom';
import './Feature.css';
import { FaEye, FaRegCalendarAlt } from 'react-icons/fa';

const Feature = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <div className="loader-text">Loading featured posts...</div>
      </div>
    );
  }

  const getColorClass = (name) => {
    const key = name?.toLowerCase().replace(/\s+/g, '');
    const colors = {
      recipes: 'bg-red',
      fastfood: 'bg-orange',
      vegetables: 'bg-purple',
      tips: 'bg-blue',
    };
    return colors[key] || 'bg-default';
  };

  return (
    <section className="featured-post-section">
      <div className="featured-header">
        <h2>Featured Posts</h2>
      </div>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          0: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
        className="featured-slider"
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <Link to={`/blog/${item.slug}`} className="featured-card">
              <img
                src={
                  item.image_500x500
                    ? `https://api.funfillia.com/${item.image_500x500}`
                    : '/images/no_image.jpg'
                }
                alt={item.title}
                title={item.title}
              />
              <span className={`tag ${getColorClass(item.category?.name)}`}>
                {item.category?.name || 'Category'}
              </span>
              <h3>{item.title}</h3>
              <p className="meta">
                <FaRegCalendarAlt/> {new Date(item.published_at).toLocaleDateString()} &nbsp;&nbsp; <FaEye/> {item.views_count} views
              </p>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Feature;
